import { render, staticRenderFns } from "./PetRewardTimeline.vue?vue&type=template&id=56ce2c3a&scoped=true&"
import script from "./PetRewardTimeline.vue?vue&type=script&lang=js&"
export * from "./PetRewardTimeline.vue?vue&type=script&lang=js&"
import style0 from "./PetRewardTimeline.vue?vue&type=style&index=0&id=56ce2c3a&prod&lang=scss&scoped=true&"
import style1 from "./PetRewardTimeline.vue?vue&type=style&index=1&id=56ce2c3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ce2c3a",
  null
  
)

export default component.exports